export default function copyCode() {

	let code = document.querySelectorAll(".copy");
	if (code.length) {
		code.forEach((text) => {
			let codeText = text.querySelector(".copy__code .input")
			let codeBtn = text.querySelector(".copy__code .copy-btn")
			let codeInfo = text.querySelector(".copy__text")

			if(codeBtn) {
				codeBtn.onclick = function() {
					copy(codeText)
					codeInfo.classList.add('active')
					setTimeout(function(){
						codeInfo.classList.remove('active');
					}, 1500);
				}
			}
		})
	}

	function copy(that){
		let inp = document.createElement('input');
		document.body.appendChild(inp)
		inp.value = that.textContent
		inp.select();
		document.execCommand('copy',false);
		inp.remove();
	}

}